import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { NotEmptyString } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";
import SidePanelLocations from "../../layout/SidePanel/layouts/SidePanelLocations";

export const LocationsSchema: ISchema = {
    displayName: "Location",
    resultsKey: "locations",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelLocations data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'name',
            displayName: 'Name',
            type: PropertyTypes.string,
            key: false,
            descriptor: true,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Name must be provided",
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'locationTypeId',
            displayName: 'Type',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.locations,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'parentId',
            displayName: 'Parent',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'level',
            displayName: 'Level',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'locationTypeName',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'isDeleted',
            displayName: 'Deleted',
            type: PropertyTypes.bool,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            valueFormatter: (val: any) => val === true ? "Yes" : "No",
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Name",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.StartsWith,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter a location name"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "ShowDeleted",
            displayName: "Show deleted",
            type: FilterTypes.toggle,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.bool,
            onValue: true,
            offValue: undefined,
            showInTab: true
        } as ISchemaFilter,
    ],

    children: [
        { entityName: EntityNames.locations, displayName: "Sub Locations", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "ParentId", canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Locations)) } as ISchemaChild,
    ],
}
